/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Confirm_DeactivateInputs */



/**
* | output |
* | --- |
* | "Deactivate Client?" |
*
* @param {Developer_Confirm_DeactivateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_confirm_deactivate = /** @type {((inputs?: Developer_Confirm_DeactivateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Confirm_DeactivateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Désactiver le client ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Desactivar cliente?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desativar Cliente?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disattivare Client?")
	return /** @type {LocalizedString} */ ("Deactivate Client?")
});